import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useState } from "react";
export const PhoneCallLegalNotice = () => {
    const { t } = useI18n();
    const [isOpen, setIsOpen] = useState(false);
    const toggleModal = () => setIsOpen(!isOpen);
    const legalText = t("hardfacts.contacting.call_tracking.legal_notice.text");
    const legalTextWithLinks = legalText.replace("{link}", `<a href="#" data-open-modal="true">${t("hardfacts.contacting.call_tracking.legal_notice.link")}</a>`);
    const handleClick = (e) => {
        // eslint-disable-next-line no-restricted-globals
        const target = e.target;
        if (target.closest('[data-open-modal="true"]')) {
            e.preventDefault();
            toggleModal();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { as: "p", typography: "typography.body.11.regular", textAlign: "center", dangerouslySetInnerHTML: { __html: legalTextWithLinks }, onClick: handleClick }), _jsx(Modal, { title: t("contact.form.legal_text.modal_label_one"), titleAs: "h2", isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: toggleModal, children: _jsx(Box, { as: "p", children: t("contact.form.legal_text.call_tracking_modal_v2") }) })] }));
};
